const cartAddUrl = window.Theme?.routes?.cart_add_url || '/cart/add.js';

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-fh-cart-upsell-add]');
  if (!form) return;

  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  if (!button || button.disabled) return;

  const translations = form.closest('[data-fh-cart-upsell]')?.dataset || {};
  const defaultLabel = button.textContent.trim();
  button.disabled = true;
  button.textContent = translations.addingLabel || defaultLabel;

  try {
    const formData = new FormData(form);
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map((component) => component.dataset.sectionId)
      .filter(Boolean);

    if (sectionIds.length) {
      formData.append('sections', [...new Set(sectionIds)].join(','));
    }

    const response = await fetch(cartAddUrl, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    });
    const result = await response.json();

    if (!response.ok || result.status) {
      throw new Error(result.description || result.message || translations.addError || 'Unable to add product.');
    }

    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((cartResponse) => {
      if (!cartResponse.ok) throw new Error(translations.updateError || 'Unable to update cart.');
      return cartResponse.json();
    });

    button.dataset.state = 'success';
    button.textContent = translations.addedLabel || defaultLabel;

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'fh-cart-upsell',
          data: {
            source: 'fh-cart-upsell',
            itemCount: Number(formData.get('quantity')) || 1,
            variantId: String(formData.get('id') || ''),
            sections: result.sections || {},
          },
        },
      }),
    );
  } catch (error) {
    console.error(error);
    button.dataset.state = 'error';
    button.textContent = translations.retryLabel || defaultLabel;
    button.disabled = false;
    window.setTimeout(() => {
      button.removeAttribute('data-state');
      button.textContent = defaultLabel;
    }, 2200);
  }
});
